import React from "react";

import { Container, Title, BalanceAndTransferContainer, BalanceCurrecy, BalanceValue, Button, PostScriptum } from "./styles";

//Interface
import { BalanceBoxPropsInterface } from "./interfaces";

const DashboardBalanceBox = (props: BalanceBoxPropsInterface) => {
    return(
        <Container>
            <Title>{props.title}</Title>
            <BalanceAndTransferContainer>
                <div className="d-flex" style={{paddingTop: 7}}>
                    <BalanceCurrecy>R$ </BalanceCurrecy>
                    {
                        Boolean(props.value)
                        ? <BalanceValue> {props.value.toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</BalanceValue>
                        : <BalanceValue> 0,00 </BalanceValue>
                    }
                    
                </div>
                
                { props.isButtonShowed ? 
                    <div>
                        <Button id={props.id} data-toggle="modal" data-target={`#${props.modalId}`}>
                            <span>{props.textButton}</span>
                            {
                                props.icon ? 
                                    <img src={props.icon} style={{marginLeft: 10, height: 13}}/>
                                : null 
                            }
                        </Button>
                    </div> : null
                }
            </BalanceAndTransferContainer>
            <PostScriptum>{props.ps}</PostScriptum>
        </Container>
    )
}

export default DashboardBalanceBox;